/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

import {
  SHOW_TOAST,
  CLEAR_TOAST,
  SET_SCRINFO,
  SET_PLAYER_STATE,
  GET_DOC,
} from "../actions/types";
import { ToastType } from "../actions/modal";
import { PlayerState } from "client/views/ClassroomPage/PlayerZone";

// InfoBox modal
export type IBoxModalState = {
  show: boolean;
  content: {
    onButtons: (action: string) => void;
  };
};

export type ScreenInfo = {
  width: number;
  height: number;
  orientation?: "landscape" | "portrait";
};

export type ModalState = {
  readonly dlgIBox: IBoxModalState;
  readonly toast: ToastType;
  readonly screenInfo: ScreenInfo;
  readonly playerState: PlayerState;
  readonly docAboutUs: string | null;
  readonly docTerms: string | null;
  readonly docPolicy: string | null;
  readonly docDisclaim: string | null;
};

const modalReducerDefaultState: ModalState = {
  dlgIBox: { show: false, content: { onButtons: (action: string) => null } },
  toast: null,
  screenInfo: { width: 0, height: 0 },
  playerState: PlayerState.Unstarted,
  docAboutUs: null,
  docTerms: null,
  docPolicy: null,
  docDisclaim: null,
};

const docData = ["docAboutUs", "docTerms", "docPolicy", "docDisclaim"];

export const modalReducer: Reducer<ModalState, AnyAction> = (
  state = modalReducerDefaultState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_PLAYER_STATE:
      return { ...state, playerState: action.payload };

    case SET_SCRINFO:
      return { ...state, screenInfo: action.payload };

    case SHOW_TOAST:
      return { ...state, toast: action.payload };

    case CLEAR_TOAST:
      return { ...state, toast: null };

    case GET_DOC: {
      const idx: number = action.payload.type;
      return { ...state, [docData[idx]]: action.payload.data };
    }

    default:
      return state;
  }
};
